var _defs, _g, _g2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAssets08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 199.99 27.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9a9b9d;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #f1f1f1;\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-6 {\n        fill: #a4a5a6;\n      }\n\n      .cls-7 {\n        fill: #707274;\n      }\n\n      .cls-8 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-9 {\n        fill: #8a8c8e;\n      }\n\n      .cls-10 {\n        fill: #97989a;\n      }\n\n      .cls-11 {\n        fill: #bebfc0;\n      }\n\n      .cls-12 {\n        fill: #dfdfdf;\n      }\n\n      .cls-13 {\n        fill: #808182;\n      }\n\n      .cls-14 {\n        fill: #acadae;\n      }\n\n      .cls-15 {\n        fill: #bfc0c1;\n      }\n\n      .cls-16 {\n        fill: #edeeee;\n      }\n\n      .cls-17 {\n        fill: #797b7d;\n      }\n\n      .cls-18 {\n        fill: #d9dada;\n      }\n\n      .cls-19 {\n        fill: #eaeaea;\n      }\n\n      .cls-20 {\n        fill: #d1d1d2;\n      }\n\n      .cls-21 {\n        fill: #e7e7e8;\n      }\n\n      .cls-22 {\n        fill: #d8d8d9;\n      }\n\n      .cls-23 {\n        fill: #e3e3e3;\n      }\n\n      .cls-24 {\n        fill: #c5c6c7;\n      }\n\n      .cls-25 {\n        fill: #e6e6e6;\n      }\n\n      .cls-26 {\n        fill: #c6c7c8;\n      }\n\n      .cls-27 {\n        fill: #ebecec;\n      }\n\n      .cls-28 {\n        fill: #aaacad;\n      }\n\n      .cls-29 {\n        fill: #e8e9e9;\n      }\n\n      .cls-30 {\n        fill: #a5a7a8;\n      }\n\n      .cls-31 {\n        fill: #9fa1a2;\n      }\n\n      .cls-32 {\n        fill: #c7c8c9;\n      }\n\n      .cls-33 {\n        fill: #efefef;\n      }\n\n      .cls-34 {\n        fill: #bcbdbe;\n      }\n\n      .cls-35 {\n        fill: #f6f6f6;\n      }\n\n      .cls-36 {\n        fill: #f4f4f4;\n      }\n\n      .cls-37 {\n        fill: #808284;\n      }\n\n      .cls-38 {\n        fill: #adafb0;\n      }\n\n      .cls-39 {\n        fill: #cecece;\n      }\n\n      .cls-40 {\n        fill: #dbdbdd;\n      }\n\n      .cls-41 {\n        fill: #e9eaea;\n      }\n\n      .cls-42 {\n        fill: #8d8f91;\n      }\n\n      .cls-43 {\n        fill: #7e8080;\n      }\n\n      .cls-44 {\n        fill: #c3c5c5;\n      }\n\n      .cls-45 {\n        fill: #cccdcd;\n      }\n\n      .cls-46 {\n        fill: #f0f0f1;\n      }\n\n      .cls-47 {\n        fill: #939597;\n      }\n\n      .cls-48 {\n        fill: #eff0f0;\n      }\n\n      .cls-49 {\n        fill: #eaecec;\n      }\n\n      .cls-50 {\n        fill: #b9babb;\n      }\n\n      .cls-51 {\n        fill: #747678;\n      }\n\n      .cls-52 {\n        fill: #b7b8ba;\n      }\n\n      .cls-53 {\n        fill: #8c8e8f;\n      }\n\n      .cls-54 {\n        fill: #e5e5e5;\n      }\n\n      .cls-55 {\n        fill: #c2c3c3;\n      }\n\n      .cls-56 {\n        fill: #ccc;\n      }\n\n      .cls-57 {\n        fill: #e6e7e7;\n      }\n\n      .cls-58 {\n        fill: #dadbdb;\n      }\n\n      .cls-59 {\n        fill: #f1f2f2;\n      }\n\n      .cls-60 {\n        fill: #c8c9ca;\n      }\n\n      .cls-61 {\n        fill: #e0e0e1;\n      }\n\n      .cls-62 {\n        fill: #ddd;\n      }\n\n      .cls-63 {\n        fill: #c4c5c5;\n      }\n\n      .cls-64 {\n        fill: #cecfcf;\n      }\n\n      .cls-65 {\n        fill: #babbbc;\n      }\n\n      .cls-66 {\n        fill: #a6a8a9;\n      }\n\n      .cls-67 {\n        fill: #7b7d7f;\n      }\n\n      .cls-68 {\n        fill: #fdd310;\n      }\n\n      .cls-69 {\n        fill: #fff;\n      }\n\n      .cls-70 {\n        fill: #eceeee;\n      }\n\n      .cls-71 {\n        fill: #9c9ea0;\n      }\n\n      .cls-3 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .34px;\n      }\n\n      .cls-72 {\n        fill: #727476;\n      }\n\n      .cls-73 {\n        fill: #929495;\n      }\n\n      .cls-74 {\n        fill: #6c6e70;\n      }\n\n      .cls-75 {\n        fill: #808081;\n      }\n\n      .cls-76 {\n        fill: #e3e5e4;\n      }\n\n      .cls-77 {\n        fill: #f9f9f9;\n      }\n\n      .cls-78 {\n        fill: #f0f0f0;\n      }\n\n      .cls-79 {\n        fill: #f4f5f5;\n      }\n\n      .cls-80 {\n        fill: #828486;\n      }\n\n      .cls-81 {\n        fill: #f3f4f4;\n      }\n\n      .cls-82 {\n        fill: #b0b1b2;\n      }\n\n      .cls-83 {\n        fill: #bdbebf;\n      }\n\n      .cls-84 {\n        fill: #e2e2e3;\n      }\n\n      .cls-85 {\n        fill: #d0d1d1;\n      }\n\n      .cls-86 {\n        fill: #9b9d9e;\n      }\n\n      .cls-87 {\n        fill: #e9e9e9;\n      }\n\n      .cls-88 {\n        fill: #6e7072;\n      }\n\n      .cls-89 {\n        fill: #999a9b;\n      }\n\n      .cls-90 {\n        fill: #7d7f80;\n      }\n\n      .cls-91 {\n        opacity: .5;\n      }\n\n      .cls-92 {\n        fill: #c0c3c3;\n      }\n\n      .cls-93 {\n        fill: #f7f7f7;\n      }\n\n      .cls-94 {\n        fill: #e5e7e6;\n      }\n\n      .cls-95 {\n        fill: #dddedf;\n      }\n\n      .cls-96 {\n        fill: #eeeeef;\n      }\n\n      .cls-97 {\n        fill: #d2d2d3;\n      }\n\n      .cls-98 {\n        fill: #aaabac;\n      }\n\n      .cls-99 {\n        fill: #f2f2f2;\n      }\n\n      .cls-100 {\n        fill: #f7f7f9;\n      }\n\n      .cls-101 {\n        fill: #d2d3d5;\n      }\n\n      .cls-102 {\n        fill: #e1e2e2;\n      }\n\n      .cls-103 {\n        fill: #f5f5f5;\n      }\n\n      .cls-104 {\n        fill: #f6f7f7;\n      }\n\n      .cls-105 {\n        fill: #aeb0b1;\n      }\n\n      .cls-106 {\n        fill: #e1e1e1;\n      }\n\n      .cls-107 {\n        fill: #e4e4e5;\n      }\n\n      .cls-108 {\n        fill: #8f9192;\n      }\n\n      .cls-109 {\n        fill: #f3f3f3;\n      }\n\n      .cls-110 {\n        fill: #898a8c;\n      }\n\n      .cls-111 {\n        fill: #b4b5b6;\n      }\n\n      .cls-112 {\n        fill: #d3d5d5;\n      }\n\n      .cls-113 {\n        fill: #dfe0e0;\n      }\n\n      .cls-114 {\n        fill: #959798;\n      }\n\n      .cls-115 {\n        fill: #898a8a;\n      }\n\n      .cls-116 {\n        fill: #b6b8b8;\n      }\n\n      .cls-117 {\n        fill: #cacbcc;\n      }\n\n      .cls-118 {\n        fill: #b2b4b5;\n      }\n\n      .cls-119 {\n        fill: #bbbcbd;\n      }\n\n      .cls-120 {\n        fill: #cfd0d0;\n      }\n\n      .cls-121 {\n        fill: #848687;\n      }\n\n      .cls-122 {\n        fill: #d7d7d8;\n      }\n\n      .cls-123 {\n        fill: #87898a;\n      }\n\n      .cls-124 {\n        fill: #b5b6b8;\n      }\n\n      .cls-125 {\n        fill: #909294;\n      }\n\n      .cls-126 {\n        fill: #77797b;\n      }\n\n      .cls-127 {\n        fill: #a8a9aa;\n      }\n\n      .cls-128 {\n        fill: #eee;\n      }\n\n      .cls-129 {\n        fill: #6a6c6e;\n      }\n\n      .cls-130 {\n        fill: #a2a4a5;\n      }\n\n      .cls-131 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-132 {\n        fill: #757779;\n      }\n\n      .cls-133 {\n        fill: #f5f6f6;\n      }\n\n      .cls-134 {\n        fill: #d4d5d5;\n      }\n\n      .cls-135 {\n        fill: #9ea0a1;\n      }\n\n      .cls-136 {\n        fill: #b1b2b3;\n      }\n\n      .cls-137 {\n        fill: #a1a2a4;\n      }\n\n      .cls-138 {\n        fill: #c9cacb;\n      }\n\n      .cls-139 {\n        fill: #d6d7d7;\n      }\n\n      .cls-140 {\n        fill: #e8e8e8;\n      }\n\n      .cls-141 {\n        fill: #d8d9da;\n      }\n\n      .cls-142 {\n        fill: #858789;\n      }\n\n      .cls-143 {\n        fill: #d5d7d7;\n      }\n\n      .cls-144 {\n        fill: #ececec;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: -14.17,
    y: -50.17,
    width: 102.87,
    height: 92.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.11,
    y: -30.29,
    width: 81.41,
    height: 52.52,
    transform: "translate(11.81 24.87) rotate(-39.45)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -14.17,
    y: -50.17,
    width: 102.87,
    height: 92.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: -0.11,
    y: -30.29,
    width: 81.41,
    height: 52.52,
    transform: "translate(11.81 24.87) rotate(-39.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M63.26-35.85c12.77,15.51,7.33,41.08-12.14,57.11-19.47,16.03-45.61,16.45-58.38.94C-13.64,14.45-15.48,4.18-13.28-6.16L-8.36-.18l49.88-41.04-4.93-5.99c10.57-.17,20.29,3.6,26.68,11.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M63.09-35.71c12.71,15.44,7.3,40.89-12.08,56.85-19.38,15.96-45.4,16.38-58.11.94C-13.46,14.35-15.28,4.13-13.09-6.16L-8.25-.27l49.65-40.85-4.86-5.9c10.52-.17,20.2,3.58,26.55,11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M62.92-35.57c12.65,15.37,7.27,40.7-12.03,56.58-19.29,15.88-45.19,16.3-57.84.94C-13.27,14.26-15.09,4.09-12.91-6.15L-8.14-.36l49.41-40.66-4.78-5.81c10.47-.17,20.1,3.57,26.43,11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M62.75-35.43c12.59,15.3,7.23,40.51-11.97,56.32-19.2,15.81-44.98,16.23-57.57.93C-13.08,14.17-14.89,4.04-12.72-6.15L-8.03-.45l49.18-40.47-4.7-5.72c10.42-.17,20.01,3.55,26.31,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M62.59-35.29c12.53,15.22,7.2,40.32-11.91,56.06-19.11,15.74-44.77,16.15-57.3.93C-12.9,14.08-14.7,4-12.54-6.15L-7.92-.54l48.95-40.28-4.63-5.63c10.37-.17,19.92,3.53,26.18,11.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M62.42-35.15c12.47,15.15,7.16,40.13-11.86,55.79-19.02,15.66-44.56,16.07-57.03.92C-12.71,13.98-14.5,3.95-12.35-6.15L-7.81-.63l48.72-40.09-4.55-5.53c10.32-.17,19.82,3.52,26.06,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M62.25-35.01c12.41,15.08,7.13,39.94-11.8,55.53-18.93,15.59-44.35,16-56.76.92C-12.52,13.89-14.3,3.91-12.17-6.14L-7.7-.72l48.49-39.9-4.48-5.44c10.27-.17,19.73,3.5,25.94,11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M62.08-34.87c12.36,15.01,7.1,39.75-11.75,55.26-18.84,15.51-44.13,15.92-56.49.91C-12.34,13.8-14.11,3.86-11.98-6.14L-7.59-.8l48.26-39.71-4.4-5.35c10.22-.17,19.63,3.48,25.81,10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M61.91-34.74c12.3,14.94,7.06,39.56-11.69,55-18.75,15.44-43.92,15.85-56.22.91C-12.15,13.7-13.91,3.81-11.8-6.14L-7.48-.89l48.03-39.52-4.32-5.26c10.17-.16,19.54,3.47,25.69,10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M61.74-34.6c12.24,14.86,7.03,39.37-11.63,54.73-18.66,15.36-43.71,15.77-55.95.9C-11.96,13.61-13.72,3.77-11.61-6.14L-7.38-.98l47.8-39.33-4.25-5.16c10.12-.16,19.45,3.45,25.57,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M61.57-34.46c12.18,14.79,6.99,39.18-11.58,54.47-18.57,15.29-43.5,15.69-55.68.9C-11.78,13.52-13.52,3.72-11.43-6.13L-7.27-1.07l47.57-39.14-4.17-5.07c10.08-.16,19.35,3.43,25.44,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M61.4-34.32c12.12,14.72,6.96,38.99-11.52,54.2-18.48,15.22-43.29,15.62-55.41.9C-11.59,13.43-13.33,3.68-11.24-6.13L-7.16-1.16l47.34-38.95-4.1-4.98c10.03-.16,19.26,3.42,25.32,10.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M61.23-34.18c12.06,14.65,6.93,38.8-11.46,53.94-18.39,15.14-43.08,15.54-55.14.89C-11.4,13.33-13.13,3.63-11.06-6.13L-7.05-1.25l47.11-38.76-4.02-4.89c9.98-.16,19.16,3.4,25.19,10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M61.06-34.04c12,14.58,6.89,38.61-11.41,53.68-18.3,15.07-42.87,15.46-54.87.89C-11.22,13.24-12.94,3.59-10.87-6.13L-6.94-1.34l46.87-38.57-3.95-4.79c9.93-.16,19.07,3.38,25.07,10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M60.89-33.9c11.94,14.51,6.86,38.42-11.35,53.41-18.21,14.99-42.66,15.39-54.6.88C-11.03,13.15-12.74,3.54-10.69-6.12L-6.83-1.43l46.64-38.38-3.87-4.7c9.88-.16,18.98,3.37,24.95,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M60.72-33.76c11.88,14.43,6.83,38.23-11.3,53.15-18.12,14.92-42.44,15.31-54.33.88C-10.84,13.05-12.55,3.5-10.5-6.12L-6.72-1.52l46.41-38.19-3.79-4.61c9.83-.16,18.88,3.35,24.82,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M60.55-33.62c11.82,14.36,6.79,38.04-11.24,52.88-18.03,14.84-42.23,15.24-54.06.87C-10.66,12.96-12.35,3.45-10.32-6.12L-6.61-1.61l46.18-38-3.72-4.52c9.78-.16,18.79,3.33,24.7,10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M60.38-33.48c11.76,14.29,6.76,37.85-11.18,52.62-17.94,14.77-42.02,15.16-53.79.87C-10.47,12.87-12.16,3.41-10.13-6.12L-6.5-1.7l45.95-37.81-3.64-4.43c9.73-.16,18.69,3.32,24.58,10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M60.21-33.34c11.71,14.22,6.72,37.66-11.13,52.35-17.85,14.7-41.81,15.08-53.52.87C-10.28,12.77-11.96,3.36-9.95-6.11L-6.39-1.79l45.72-37.62-3.57-4.33c9.68-.16,18.6,3.3,24.45,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M60.05-33.2c11.65,14.15,6.69,37.47-11.07,52.09-17.76,14.62-41.6,15.01-53.25.86C-10.1,12.68-11.77,3.31-9.76-6.11L-6.28-1.88l45.49-37.43-3.49-4.24c9.64-.16,18.51,3.28,24.33,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M59.88-33.06c11.59,14.07,6.66,37.28-11.02,51.83-17.67,14.55-41.39,14.93-52.98.86C-9.91,12.59-11.57,3.27-9.58-6.11L-6.17-1.97l45.26-37.24-3.41-4.15c9.59-.16,18.41,3.27,24.21,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M59.71-32.92c11.53,14,6.62,37.09-10.96,51.56-17.58,14.47-41.18,14.85-52.71.85C-9.72,12.5-11.38,3.22-9.39-6.11l3.33,4.05,45.03-37.05-3.34-4.06c9.54-.15,18.32,3.25,24.08,10.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M59.54-32.78c11.47,13.93,6.59,36.9-10.9,51.3-17.49,14.4-40.97,14.78-52.44.85C-9.54,12.4-11.18,3.18-9.21-6.1l3.25,3.95,44.8-36.86-3.26-3.96c9.49-.15,18.23,3.23,23.96,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M59.37-32.64c11.41,13.86,6.55,36.71-10.85,51.03-17.4,14.32-40.76,14.7-52.16.84C-9.35,12.31-10.99,3.13-9.02-6.1l3.18,3.86,44.57-36.67-3.19-3.87c9.44-.15,18.13,3.22,23.84,10.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M59.2-32.5c11.35,13.79,6.52,36.52-10.79,50.77-17.31,14.25-40.54,14.63-51.89.84C-9.16,12.22-10.79,3.09-8.84-6.1l3.1,3.77,44.33-36.48-3.11-3.78c9.39-.15,18.04,3.2,23.71,10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M59.03-32.36c11.29,13.72,6.49,36.33-10.73,50.5-17.22,14.18-40.33,14.55-51.62.83-5.65-6.86-7.27-15.94-5.32-25.08l3.02,3.68,44.1-36.29-3.03-3.69c9.34-.15,17.94,3.18,23.59,10.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M58.86-32.22c11.23,13.64,6.45,36.14-10.68,50.24-17.13,14.1-40.12,14.47-51.35.83-5.62-6.82-7.23-15.86-5.3-24.95l2.95,3.58,43.87-36.1-2.96-3.6c9.29-.15,17.85,3.17,23.47,9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M58.69-32.08c11.17,13.57,6.42,35.95-10.62,49.97-17.04,14.03-39.91,14.4-51.08.83-5.59-6.79-7.19-15.77-5.27-24.82l2.87,3.49,43.64-35.91-2.88-3.5c9.24-.15,17.76,3.15,23.34,9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M58.52-31.94c11.11,13.5,6.38,35.76-10.57,49.71-16.95,13.95-39.7,14.32-50.81.82-5.56-6.75-7.15-15.69-5.24-24.68l2.8,3.4,43.41-35.72-2.81-3.41c9.2-.15,17.66,3.13,23.22,9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M58.35-31.8c11.06,13.43,6.35,35.57-10.51,49.45-16.86,13.88-39.49,14.25-50.54.82C-8.23,11.75-9.82,2.86-7.91-6.09l2.72,3.31,43.18-35.53-2.73-3.32c9.15-.15,17.57,3.12,23.1,9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M58.18-31.66c11,13.36,6.32,35.38-10.45,49.18-16.77,13.81-39.28,14.17-50.27.81C-8.04,11.66-9.62,2.81-7.73-6.09l2.65,3.22,42.95-35.34-2.65-3.23c9.1-.15,17.47,3.1,22.97,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M58.01-31.52c10.94,13.28,6.28,35.19-10.4,48.92-16.68,13.73-39.07,14.09-50,.81C-7.86,11.57-9.43,2.77-7.54-6.08l2.57,3.12,42.72-35.15-2.58-3.13c9.05-.15,17.38,3.08,22.85,9.73Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-77",
    cx: 27.81,
    cy: -6.65,
    rx: 38.91,
    ry: 30.99,
    transform: "translate(10.57 16.16) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-100",
    cx: 27.8,
    cy: -6.64,
    rx: 38.69,
    ry: 30.82,
    transform: "translate(10.56 16.16) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 27.79,
    cy: -6.64,
    rx: 38.48,
    ry: 30.65,
    transform: "translate(10.56 16.15) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M57.34-30.96c10.7,13,6.15,34.42-10.17,47.86-16.32,13.43-38.22,13.79-48.92.79C-12.46,4.7-7.9-16.73,8.41-30.17c16.32-13.43,38.22-13.79,48.92-.79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 27.78,
    cy: -6.63,
    rx: 38.06,
    ry: 30.31,
    transform: "translate(10.55 16.15) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 27.78,
    cy: -6.62,
    rx: 37.85,
    ry: 30.15,
    transform: "translate(10.54 16.14) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-104",
    cx: 27.77,
    cy: -6.62,
    rx: 37.64,
    ry: 29.98,
    transform: "translate(10.54 16.14) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M56.66-30.4c10.46,12.71,6.01,33.66-9.95,46.8-15.96,13.14-37.38,13.48-47.84.77C-11.59,4.47-7.14-16.49,8.82-29.62c15.96-13.14,37.38-13.48,47.84-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M56.49-30.26c10.4,12.64,5.98,33.47-9.89,46.54-15.87,13.06-37.17,13.41-47.57.77C-11.38,4.41-6.95-16.43,8.92-29.49c15.87-13.06,37.17-13.41,47.57-.77Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 27.75,
    cy: -6.6,
    rx: 37,
    ry: 29.47,
    transform: "translate(10.52 16.13) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-133",
    cx: 27.75,
    cy: -6.59,
    rx: 36.79,
    ry: 29.3,
    transform: "translate(10.52 16.13) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M55.98-29.84c10.23,12.42,5.87,32.9-9.72,45.74-15.6,12.84-36.53,13.18-46.76.76C-10.73,4.24-6.38-16.24,9.22-29.08c15.6-12.84,36.53-13.18,46.76-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M55.81-29.7c10.17,12.35,5.84,32.71-9.67,45.48S9.82,28.88-.34,16.53C-10.51,4.18-6.18-16.18,9.32-28.95c15.51-12.77,36.32-13.1,46.49-.75Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-103",
    cx: 27.73,
    cy: -6.58,
    rx: 36.16,
    ry: 28.8,
    transform: "translate(10.5 16.12) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-79",
    cx: 27.72,
    cy: -6.57,
    rx: 35.95,
    ry: 28.63,
    transform: "translate(10.5 16.12) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 27.71,
    cy: -6.57,
    rx: 35.73,
    ry: 28.46,
    transform: "translate(10.49 16.12) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 27.71,
    cy: -6.56,
    rx: 35.52,
    ry: 28.29,
    transform: "translate(10.49 16.12) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-81",
    cx: 27.7,
    cy: -6.56,
    rx: 35.31,
    ry: 28.13,
    transform: "translate(10.48 16.11) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M54.79-28.86c9.81,11.92,5.64,31.57-9.33,43.89C30.5,27.35,10.41,27.68.6,15.76-9.22,3.84-5.04-15.81,9.93-28.13c14.97-12.32,35.05-12.65,44.87-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M54.63-28.72c9.75,11.85,5.6,31.38-9.27,43.63C30.48,27.16,10.51,27.48.76,15.63-9,3.78-4.85-15.75,10.03-28c14.88-12.25,34.84-12.57,44.6-.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-109",
    cx: 27.68,
    cy: -6.54,
    rx: 34.68,
    ry: 27.62,
    transform: "translate(10.47 16.11) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-99",
    cx: 27.68,
    cy: -6.53,
    rx: 34.47,
    ry: 27.45,
    transform: "translate(10.46 16.1) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-99",
    cx: 27.67,
    cy: -6.53,
    rx: 34.25,
    ry: 27.28,
    transform: "translate(10.46 16.1) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M53.95-28.16c9.52,11.56,5.47,30.62-9.05,42.57-14.52,11.95-34,12.27-43.52.7C-8.13,3.55-4.08-15.51,10.43-27.46c14.52-11.95,34-12.27,43.52-.7Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 27.66,
    cy: -6.52,
    rx: 33.83,
    ry: 26.95,
    transform: "translate(10.45 16.09) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 27.65,
    cy: -6.51,
    rx: 33.62,
    ry: 26.78,
    transform: "translate(10.44 16.09) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 27.65,
    cy: -6.51,
    rx: 33.41,
    ry: 26.61,
    transform: "translate(10.44 16.09) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M53.27-27.6c9.28,11.27,5.33,29.86-8.82,41.51-14.15,11.65-33.15,11.96-42.43.69C-7.27,3.33-3.32-15.26,10.84-26.91c14.15-11.65,33.15-11.96,42.43-.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 27.64,
    cy: -6.49,
    rx: 32.99,
    ry: 26.27,
    transform: "translate(10.43 16.08) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 27.63,
    cy: -6.49,
    rx: 32.77,
    ry: 26.1,
    transform: "translate(10.42 16.08) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 27.62,
    cy: -6.48,
    rx: 32.56,
    ry: 25.94,
    transform: "translate(10.42 16.08) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M52.59-27.04c9.04,10.99,5.2,29.1-8.6,40.46-13.79,11.36-32.31,11.66-41.35.67C-6.4,3.1-2.55-15.02,11.24-26.37c13.79-11.36,32.31-11.66,41.35-.67Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128",
    cx: 27.61,
    cy: -6.47,
    rx: 32.14,
    ry: 25.6,
    transform: "translate(10.41 16.07) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 27.6,
    cy: -6.47,
    rx: 31.93,
    ry: 25.43,
    transform: "translate(10.4 16.07) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128",
    cx: 27.6,
    cy: -6.46,
    rx: 31.72,
    ry: 25.26,
    transform: "translate(10.4 16.07) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 27.59,
    cy: -6.46,
    rx: 31.51,
    ry: 25.09,
    transform: "translate(10.39 16.07) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M51.75-26.34c8.75,10.63,5.03,28.15-8.32,39.13-13.34,10.99-31.25,11.27-40,.65C-5.32,2.81-1.6-14.71,11.74-25.69c13.34-10.99,31.25-11.27,40-.65Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 27.58,
    cy: -6.45,
    rx: 31.08,
    ry: 24.76,
    transform: "translate(10.38 16.06) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M51.41-26.06c8.63,10.48,4.96,27.77-8.21,38.6-13.16,10.84-30.83,11.12-39.46.64C-4.89,2.7-1.22-14.59,11.95-25.42c13.16-10.84,30.83-11.12,39.46-.64Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 27.57,
    cy: -6.43,
    rx: 30.66,
    ry: 24.42,
    transform: "translate(10.37 16.05) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 27.56,
    cy: -6.43,
    rx: 30.45,
    ry: 24.25,
    transform: "translate(10.37 16.05) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 27.56,
    cy: -6.42,
    rx: 30.24,
    ry: 24.08,
    transform: "translate(10.36 16.05) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-87",
    cx: 27.55,
    cy: -6.42,
    rx: 30.03,
    ry: 23.91,
    transform: "translate(10.36 16.05) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 27.54,
    cy: -6.41,
    rx: 29.81,
    ry: 23.75,
    transform: "translate(10.35 16.04) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-140",
    cx: 27.54,
    cy: -6.41,
    rx: 29.6,
    ry: 23.58,
    transform: "translate(10.35 16.04) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 27.53,
    cy: -6.4,
    rx: 29.39,
    ry: 23.41,
    transform: "translate(10.34 16.04) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M50.05-24.94c8.16,9.91,4.69,26.25-7.76,36.49-12.44,10.24-29.14,10.51-37.3.6C-3.16,2.24.31-14.1,12.75-24.34c12.44-10.24,29.14-10.51,37.3-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M49.88-24.8c8.1,9.84,4.65,26.06-7.7,36.22-12.35,10.17-28.93,10.44-37.03.6C-2.94,2.18.5-14.03,12.85-24.2c12.35-10.17,28.93-10.44,37.03-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M49.71-24.66c8.04,9.77,4.62,25.87-7.64,35.96-12.26,10.09-28.72,10.36-36.76.59C-2.73,2.13.69-13.97,12.96-24.07c12.26-10.09,28.72-10.36,36.76-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M49.54-24.52c7.98,9.69,4.58,25.68-7.59,35.7-12.17,10.02-28.51,10.28-36.49.59C-2.51,2.07.88-13.91,13.06-23.93c12.17-10.02,28.51-10.28,36.49-.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-107",
    cx: 27.5,
    cy: -6.37,
    rx: 28.33,
    ry: 22.57,
    transform: "translate(10.32 16.03) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 27.49,
    cy: -6.37,
    rx: 28.12,
    ry: 22.4,
    transform: "translate(10.32 16.02) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 27.49,
    cy: -6.36,
    rx: 27.91,
    ry: 22.23,
    transform: "translate(10.31 16.02) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M48.87-23.96c7.74,9.41,4.45,24.91-7.36,34.64-11.81,9.72-27.66,9.98-35.41.57C-1.65,1.84,1.65-13.67,13.46-23.39c11.81-9.72,27.66-9.98,35.41-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M48.7-23.82c7.69,9.34,4.41,24.72-7.31,34.37-11.72,9.65-27.45,9.9-35.14.57C-1.43,1.78,1.84-13.61,13.56-23.25c11.72-9.65,27.45-9.9,35.14-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M48.53-23.68c7.63,9.26,4.38,24.53-7.25,34.11-11.63,9.57-27.24,9.83-34.87.56C-1.21,1.73,2.03-13.54,13.66-23.12c11.63-9.57,27.24-9.83,34.87-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M48.36-23.54c7.57,9.19,4.35,24.34-7.19,33.84-11.54,9.5-27.03,9.75-34.6.56C-1,1.67,2.22-13.48,13.76-22.98c11.54-9.5,27.03-9.75,34.6-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M48.19-23.4c7.51,9.12,4.31,24.15-7.14,33.58-11.45,9.43-26.82,9.68-34.33.56C-.78,1.61,2.41-13.42,13.86-22.85c11.45-9.43,26.82-9.67,34.33-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M48.02-23.26c7.45,9.05,4.28,23.96-7.08,33.32-11.36,9.35-26.61,9.6-34.06.55C-.57,1.56,2.6-13.36,13.96-22.71c11.36-9.35,26.61-9.6,34.06-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.85-23.12c7.39,8.98,4.24,23.77-7.03,33.05-11.27,9.28-26.4,9.52-33.79.55C-.35,1.5,2.8-13.3,14.07-22.58c11.27-9.28,26.4-9.52,33.79-.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-95",
    cx: 27.44,
    cy: -6.32,
    rx: 26.22,
    ry: 20.88,
    transform: "translate(10.27 16) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-62",
    cx: 27.43,
    cy: -6.31,
    rx: 26.01,
    ry: 20.71,
    transform: "translate(10.27 16) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M47.34-22.7c7.21,8.76,4.14,23.2-6.86,32.26-11,9.06-25.76,9.29-32.97.53C.3,1.33,3.37-13.11,14.37-22.17c11-9.06,25.76-9.29,32.97-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M47.17-22.56c7.15,8.69,4.11,23.01-6.8,31.99-10.91,8.98-25.55,9.22-32.7.53C.52,1.27,3.56-13.05,14.47-22.03c10.91-8.98,25.55-9.22,32.7-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M47-22.42c7.09,8.62,4.07,22.82-6.74,31.73-10.82,8.91-25.34,9.14-32.43.52C.73,1.21,3.75-12.99,14.57-21.9c10.82-8.91,25.34-9.14,32.43-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M46.83-22.28c7.03,8.55,4.04,22.63-6.69,31.47-10.73,8.83-25.13,9.07-32.16.52C.95,1.16,3.94-12.93,14.67-21.76c10.73-8.83,25.13-9.07,32.16-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M46.67-22.14c6.98,8.47,4.01,22.44-6.63,31.2-10.64,8.76-24.92,8.99-31.89.52C1.16,1.1,4.13-12.87,14.77-21.63s24.92-8.99,31.89-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M46.5-22c6.92,8.4,3.97,22.25-6.58,30.94-10.55,8.68-24.71,8.91-31.62.51C1.38,1.04,4.32-12.81,14.87-21.49c10.55-8.68,24.71-8.91,31.62-.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-122",
    cx: 27.39,
    cy: -6.27,
    rx: 24.53,
    ry: 19.54,
    transform: "translate(10.23 15.98) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-139",
    cx: 27.38,
    cy: -6.27,
    rx: 24.32,
    ry: 19.37,
    transform: "translate(10.23 15.98) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M45.99-21.58c6.74,8.19,3.87,21.68-6.41,30.14-10.28,8.46-24.07,8.68-30.81.5C2.03.87,4.9-12.62,15.18-21.09c10.28-8.46,24.07-8.68,30.81-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M45.82-21.44c6.68,8.11,3.84,21.49-6.35,29.88-10.19,8.39-23.86,8.61-30.54.49C2.25.81,5.09-12.56,15.28-20.95c10.19-8.39,23.86-8.61,30.54-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M45.65-21.3C52.27-13.26,49.45,0,39.35,8.31c-10.1,8.31-23.65,8.53-30.27.49C2.46.76,5.28-12.5,15.38-20.81c10.1-8.31,23.65-8.53,30.27-.49Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-101",
    cx: 27.36,
    cy: -6.25,
    rx: 23.47,
    ry: 18.69,
    transform: "translate(10.21 15.97) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M45.31-21.02c6.5,7.9,3.74,20.92-6.18,29.09-9.92,8.16-23.23,8.38-29.73.48C2.89.64,5.66-12.38,15.58-20.54c9.92-8.16,23.23-8.38,29.73-.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 27.35,
    cy: -6.24,
    rx: 23.05,
    ry: 18.36,
    transform: "translate(10.2 15.96) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M44.97-20.74c6.38,7.76,3.67,20.54-6.07,28.56-9.74,8.02-22.81,8.23-29.19.47C3.33.53,6.04-12.26,15.78-20.27c9.74-8.02,22.81-8.23,29.19-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M44.8-20.6c6.33,7.68,3.63,20.35-6.01,28.29-9.65,7.94-22.59,8.15-28.92.47C3.54.47,6.23-12.2,15.88-20.14c9.65-7.94,22.59-8.15,28.92-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M44.63-20.46c6.27,7.61,3.6,20.16-5.96,28.03-9.56,7.87-22.38,8.07-28.65.46C3.76.41,6.43-12.13,15.98-20c9.56-7.87,22.38-8.08,28.65-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M44.46-20.33c6.21,7.54,3.57,19.97-5.9,27.76-9.47,7.79-22.17,8-28.38.46C3.98.36,6.62-12.07,16.08-19.87c9.47-7.79,22.17-8,28.38-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M44.29-20.19c6.15,7.47,3.53,19.78-5.84,27.5-9.38,7.72-21.96,7.92-28.11.45C4.19.3,6.81-12.01,16.18-19.73c9.38-7.72,21.96-7.92,28.11-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M44.12-20.05c6.09,7.4,3.5,19.59-5.79,27.23-9.29,7.64-21.75,7.85-27.84.45C4.41.24,7-11.95,16.29-19.6c9.29-7.64,21.75-7.85,27.84-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M43.96-19.91c6.03,7.32,3.46,19.4-5.73,26.97-9.2,7.57-21.54,7.77-27.57.45C4.62.19,7.19-11.89,16.39-19.46c9.2-7.57,21.54-7.77,27.57-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M43.79-19.77c5.97,7.25,3.43,19.21-5.68,26.71-9.11,7.5-21.33,7.69-27.3.44C4.84.13,7.38-11.83,16.49-19.32c9.11-7.5,21.33-7.69,27.3-.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-60",
    cx: 27.29,
    cy: -6.19,
    rx: 21.14,
    ry: 16.84,
    transform: "translate(10.15 15.94) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 27.29,
    cy: -6.18,
    rx: 20.93,
    ry: 16.67,
    transform: "translate(10.15 15.93) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M43.28-19.35c5.79,7.04,3.33,18.64-5.51,25.91-8.84,7.27-20.69,7.47-26.49.43C5.49-.04,7.95-11.64,16.79-18.92c8.84-7.27,20.69-7.47,26.49-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M43.11-19.21c5.73,6.97,3.29,18.45-5.45,25.65-8.75,7.2-20.48,7.39-26.22.42C5.71-.1,8.15-11.58,16.89-18.78c8.75-7.2,20.48-7.39,26.22-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M42.94-19.07c5.68,6.89,3.26,18.26-5.4,25.38-8.65,7.13-20.27,7.31-25.95.42C5.92-.16,8.34-11.52,16.99-18.65c8.66-7.13,20.27-7.31,25.95-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M42.77-18.93c5.62,6.82,3.23,18.07-5.34,25.12-8.56,7.05-20.06,7.24-25.68.42C6.14-.21,8.53-11.46,17.09-18.51c8.56-7.05,20.06-7.24,25.68-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M42.6-18.79c5.56,6.75,3.19,17.88-5.28,24.85-8.47,6.98-19.85,7.16-25.41.41C6.35-.27,8.72-11.4,17.19-18.38c8.47-6.98,19.85-7.16,25.41-.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-92",
    cx: 27.25,
    cy: -6.15,
    rx: 19.66,
    ry: 15.66,
    transform: "translate(10.12 15.92) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M42.26-18.51c5.44,6.61,3.12,17.5-5.17,24.33-8.29,6.83-19.43,7.01-24.87.4C6.79-.38,9.1-11.28,17.4-18.1c8.29-6.83,19.43-7.01,24.87-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M42.09-18.37c5.38,6.53,3.09,17.31-5.11,24.06-8.2,6.75-19.22,6.93-24.6.4C7-.44,9.29-11.21,17.5-17.97c8.2-6.75,19.22-6.93,24.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M41.92-18.23c5.32,6.46,3.06,17.12-5.06,23.8-8.11,6.68-19.01,6.86-24.33.39C7.22-.5,9.48-11.15,17.6-17.83c8.11-6.68,19-6.86,24.33-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M41.75-18.09c5.26,6.39,3.02,16.93-5,23.53-8.02,6.61-18.79,6.78-24.06.39-5.26-6.39-3.02-16.93,5-23.53,8.02-6.61,18.79-6.78,24.06-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M41.58-17.95c5.2,6.32,2.99,16.74-4.95,23.27-7.93,6.53-18.58,6.7-23.78.38-5.2-6.32-2.99-16.74,4.95-23.27,7.93-6.53,18.58-6.7,23.79-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M41.41-17.81c5.14,6.25,2.95,16.55-4.89,23-7.84,6.46-18.37,6.63-23.51.38-5.14-6.25-2.95-16.55,4.89-23,7.84-6.46,18.37-6.63,23.51-.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-50",
    cx: 27.21,
    cy: -6.11,
    rx: 18.18,
    ry: 14.48,
    transform: "translate(10.09 15.9) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M41.08-17.53c5.02,6.1,2.89,16.17-4.78,22.48-7.66,6.31-17.95,6.48-22.97.37-5.02-6.1-2.89-16.17,4.78-22.48s17.95-6.48,22.97-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M40.91-17.39c4.97,6.03,2.85,15.98-4.72,22.21-7.57,6.23-17.74,6.4-22.7.37-4.97-6.03-2.85-15.98,4.72-22.21,7.57-6.23,17.74-6.4,22.7-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M40.74-17.25c4.91,5.96,2.82,15.79-4.66,21.95-7.48,6.16-17.53,6.32-22.43.36-4.91-5.96-2.82-15.79,4.66-21.95,7.48-6.16,17.53-6.32,22.43-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M40.57-17.11c4.85,5.89,2.78,15.6-4.61,21.68s-17.32,6.25-22.16.36c-4.85-5.89-2.78-15.6,4.61-21.68,7.39-6.09,17.32-6.25,22.16-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M40.4-16.97c4.79,5.82,2.75,15.41-4.55,21.42-7.3,6.01-17.1,6.17-21.89.35-4.79-5.82-2.75-15.41,4.55-21.42,7.3-6.01,17.1-6.17,21.89-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M40.23-16.83c4.73,5.74,2.72,15.22-4.5,21.15-7.21,5.94-16.89,6.09-21.62.35-4.73-5.74-2.72-15.22,4.5-21.15,7.21-5.94,16.89-6.09,21.62-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M40.06-16.69c4.67,5.67,2.68,15.03-4.44,20.89-7.12,5.86-16.68,6.02-21.35.35-4.67-5.67-2.68-15.03,4.44-20.89,7.12-5.86,16.68-6.02,21.35-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M39.89-16.55c4.61,5.6,2.65,14.83-4.38,20.62-7.03,5.79-16.47,5.94-21.08.34s-2.65-14.83,4.38-20.62c7.03-5.79,16.47-5.94,21.08-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M39.72-16.41c4.55,5.53,2.61,14.64-4.33,20.36-6.94,5.72-16.26,5.87-20.81.34s-2.61-14.64,4.33-20.36c6.94-5.72,16.26-5.87,20.81-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M39.55-16.27c4.49,5.46,2.58,14.45-4.27,20.1-6.85,5.64-16.05,5.79-20.54.33-4.49-5.46-2.58-14.45,4.27-20.1,6.85-5.64,16.05-5.79,20.54-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M39.38-16.13c4.43,5.39,2.55,14.26-4.22,19.83-6.76,5.57-15.84,5.71-20.27.33-4.43-5.39-2.55-14.26,4.21-19.83s15.84-5.71,20.27-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M39.21-15.99c4.37,5.31,2.51,14.07-4.16,19.57-6.67,5.49-15.63,5.64-20,.32-4.37-5.31-2.51-14.07,4.16-19.57s15.63-5.64,20-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M39.04-15.85c4.32,5.24,2.48,13.88-4.1,19.3-6.58,5.42-15.42,5.56-19.73.32-4.32-5.24-2.48-13.88,4.1-19.3,6.58-5.42,15.42-5.56,19.73-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M38.87-15.71c4.26,5.17,2.44,13.69-4.05,19.04-6.49,5.34-15.2,5.49-19.46.31-4.26-5.17-2.44-13.69,4.05-19.04,6.49-5.34,15.2-5.49,19.46-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M38.7-15.57c4.2,5.1,2.41,13.5-3.99,18.77-6.4,5.27-14.99,5.41-19.19.31-4.2-5.1-2.41-13.5,3.99-18.77,6.4-5.27,14.99-5.41,19.19-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.54-15.43c4.14,5.03,2.38,13.31-3.93,18.51-6.31,5.2-14.78,5.33-18.92.31-4.14-5.03-2.38-13.31,3.93-18.51,6.31-5.2,14.78-5.33,18.92-.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-130",
    cx: 27.1,
    cy: -6.02,
    rx: 14.59,
    ry: 11.62,
    transform: "translate(10 15.85) rotate(-39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M38.2-15.15c4.02,4.88,2.31,12.93-3.82,17.98-6.13,5.05-14.36,5.18-18.38.3-4.02-4.88-2.31-12.93,3.82-17.98s14.36-5.18,18.38-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M38.03-15.01c3.96,4.81,2.27,12.74-3.77,17.72s-14.15,5.1-18.11.29c-3.96-4.81-2.27-12.74,3.77-17.72,6.04-4.97,14.15-5.1,18.11-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M37.86-14.87c3.9,4.74,2.24,12.55-3.71,17.45-5.95,4.9-13.94,5.03-17.84.29-3.9-4.74-2.24-12.55,3.71-17.45,5.95-4.9,13.94-5.03,17.84-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M37.69-14.73c3.84,4.67,2.21,12.36-3.65,17.19-5.86,4.82-13.73,4.95-17.57.28-3.84-4.67-2.21-12.36,3.65-17.19,5.86-4.82,13.73-4.95,17.57-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M37.52-14.59c3.78,4.6,2.17,12.17-3.6,16.92-5.77,4.75-13.51,4.88-17.3.28-3.78-4.6-2.17-12.17,3.6-16.92,5.77-4.75,13.51-4.88,17.3-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.35-14.45c3.72,4.52,2.14,11.98-3.54,16.66-5.68,4.68-13.3,4.8-17.03.28-3.72-4.52-2.14-11.98,3.54-16.66s13.3-4.8,17.03-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M37.18-14.31c3.67,4.45,2.11,11.79-3.48,16.39-5.59,4.6-13.09,4.72-16.76.27-3.67-4.45-2.11-11.79,3.48-16.39,5.59-4.6,13.09-4.72,16.76-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37.01-14.17c3.61,4.38,2.07,11.6-3.43,16.13-5.5,4.53-12.88,4.65-16.49.27-3.61-4.38-2.07-11.6,3.43-16.13,5.5-4.53,12.88-4.65,16.49-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M36.84-14.03c3.55,4.31,2.04,11.41-3.37,15.86-5.41,4.45-12.67,4.57-16.22.26s-2.04-11.41,3.37-15.86c5.41-4.45,12.67-4.57,16.22-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M36.67-13.89c3.49,4.24,2,11.22-3.32,15.6-5.32,4.38-12.46,4.49-15.95.26-3.49-4.24-2-11.22,3.32-15.6,5.32-4.38,12.46-4.49,15.95-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M36.5-13.75c3.43,4.17,1.97,11.03-3.26,15.34-5.23,4.31-12.25,4.42-15.68.25-3.43-4.16-1.97-11.03,3.26-15.34,5.23-4.3,12.25-4.42,15.68-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M36.33-13.61c3.37,4.09,1.94,10.84-3.2,15.07-5.14,4.23-12.04,4.34-15.41.25-3.37-4.09-1.94-10.84,3.2-15.07,5.14-4.23,12.04-4.34,15.41-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M36.16-13.47c3.31,4.02,1.9,10.65-3.15,14.81s-11.83,4.27-15.14.24c-3.31-4.02-1.9-10.65,3.15-14.81s11.83-4.27,15.14-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M36-13.33c3.25,3.95,1.87,10.46-3.09,14.54-4.96,4.08-11.61,4.19-14.87.24-3.25-3.95-1.87-10.46,3.09-14.54,4.96-4.08,11.61-4.19,14.87-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M35.83-13.19c3.19,3.88,1.83,10.27-3.03,14.28-4.87,4.01-11.4,4.11-14.6.24-3.19-3.88-1.83-10.27,3.03-14.28,4.87-4.01,11.4-4.11,14.6-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.66-13.05c3.13,3.81,1.8,10.08-2.98,14.01-4.78,3.93-11.19,4.04-14.33.23-3.13-3.81-1.8-10.08,2.98-14.01,4.78-3.93,11.19-4.04,14.33-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M35.49-12.91c3.07,3.73,1.77,9.89-2.92,13.75-4.69,3.86-10.98,3.96-14.05.23-3.07-3.73-1.77-9.89,2.92-13.75,4.69-3.86,10.98-3.96,14.05-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M35.32-12.77c3.02,3.66,1.73,9.7-2.87,13.49-4.6,3.79-10.77,3.89-13.78.22-3.02-3.66-1.73-9.7,2.87-13.49,4.6-3.79,10.77-3.89,13.78-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M35.15-12.63c2.96,3.59,1.7,9.51-2.81,13.22s-10.56,3.81-13.51.22c-2.96-3.59-1.7-9.51,2.81-13.22,4.51-3.71,10.56-3.81,13.51-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M34.98-12.49c2.9,3.52,1.66,9.32-2.75,12.96-4.42,3.64-10.35,3.73-13.24.21-2.9-3.52-1.66-9.32,2.75-12.96s10.35-3.73,13.24-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M34.81-12.35c2.84,3.45,1.63,9.13-2.7,12.69-4.33,3.56-10.14,3.66-12.97.21-2.84-3.45-1.63-9.13,2.7-12.69,4.33-3.56,10.14-3.66,12.97-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M34.64-12.21c2.78,3.37,1.6,8.94-2.64,12.43-4.24,3.49-9.92,3.58-12.7.21-2.78-3.38-1.6-8.94,2.64-12.43,4.24-3.49,9.92-3.58,12.7-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M34.47-12.07c2.72,3.3,1.56,8.75-2.59,12.16-4.15,3.41-9.71,3.5-12.43.2-2.72-3.3-1.56-8.75,2.59-12.16,4.15-3.41,9.71-3.5,12.43-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M34.3-11.93c2.66,3.23,1.53,8.56-2.53,11.9-4.06,3.34-9.5,3.43-12.16.2-2.66-3.23-1.53-8.56,2.53-11.9,4.06-3.34,9.5-3.43,12.16-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M34.13-11.79c2.6,3.16,1.49,8.37-2.47,11.63-3.97,3.27-9.29,3.35-11.89.19-2.6-3.16-1.49-8.37,2.47-11.63,3.97-3.27,9.29-3.35,11.89-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M33.96-11.65c2.54,3.09,1.46,8.18-2.42,11.37-3.88,3.19-9.08,3.28-11.62.19-2.54-3.09-1.46-8.18,2.42-11.37,3.88-3.19,9.08-3.28,11.62-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M33.79-11.51c2.48,3.02,1.43,7.99-2.36,11.11-3.79,3.12-8.87,3.2-11.35.18s-1.43-7.99,2.36-11.11c3.79-3.12,8.87-3.2,11.35-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M33.62-11.37c2.42,2.94,1.39,7.8-2.3,10.84-3.7,3.04-8.66,3.12-11.08.18-2.42-2.94-1.39-7.8,2.3-10.84,3.7-3.04,8.66-3.12,11.08-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M33.45-11.23c2.36,2.87,1.36,7.61-2.25,10.58-3.61,2.97-8.45,3.05-10.81.17-2.36-2.87-1.36-7.61,2.25-10.58,3.61-2.97,8.45-3.05,10.81-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M33.29-11.09c2.31,2.8,1.32,7.42-2.19,10.31-3.52,2.89-8.24,2.97-10.54.17-2.31-2.8-1.32-7.42,2.19-10.31,3.52-2.89,8.24-2.97,10.54-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M33.12-10.95c2.25,2.73,1.29,7.23-2.14,10.05-3.43,2.82-8.02,2.89-10.27.17-2.25-2.73-1.29-7.23,2.14-10.05,3.43-2.82,8.02-2.89,10.27-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M32.95-10.81c2.19,2.66,1.26,7.04-2.08,9.78-3.34,2.75-7.81,2.82-10,.16-2.19-2.66-1.26-7.04,2.08-9.78,3.34-2.75,7.81-2.82,10-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M32.78-10.67c2.13,2.59,1.22,6.85-2.02,9.52s-7.6,2.74-9.73.16c-2.13-2.59-1.22-6.85,2.02-9.52,3.25-2.67,7.6-2.74,9.73-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.61-10.53c2.07,2.51,1.19,6.66-1.97,9.25-3.16,2.6-7.39,2.67-9.46.15-2.07-2.51-1.19-6.66,1.97-9.25,3.16-2.6,7.39-2.67,9.46-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M32.44-10.39c2.01,2.44,1.15,6.47-1.91,8.99-3.07,2.52-7.18,2.59-9.19.15-2.01-2.44-1.15-6.47,1.91-8.99,3.07-2.52,7.18-2.59,9.19-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M32.27-10.25c1.95,2.37,1.12,6.28-1.85,8.73-2.98,2.45-6.97,2.51-8.92.14-1.95-2.37-1.12-6.28,1.85-8.73,2.98-2.45,6.97-2.51,8.92-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M32.1-10.11c1.89,2.3,1.09,6.09-1.8,8.46-2.88,2.38-6.76,2.44-8.65.14s-1.09-6.09,1.8-8.46c2.89-2.38,6.76-2.44,8.65-.14Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M132.42,2.9c-.24.01-1.49.31-2.6,1.25-.07.06-.2.23-.19.6v17.64s.03.05.06.04c.4-.15,2.78-1.24,2.78-2.82V2.95s-.02-.05-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M179.15,8s-.28-.09-1.19-.09-1.3.09-1.3.09c-.11.02-.17.07-.17.17v11.4c0,.22.18.41.41.41h2.28c.08,0,.14-.06.14-.14v-11.67c0-.09-.07-.14-.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M175.23,8.54c-.47-.42-.98-.68-1.63-.68-1.08,0-1.8.51-2.25,1.42l-1.66-1.51s-.33-.26-.59.05l-.89.9-.71.72s-.25.21-.01.44c.24.23.93.7,1.11.98,0,0,.08.08.08.41v8.28c0,.22.18.41.41.41h2.29c.08,0,.14-.06.14-.14v-8.54h0c0-.63.47-1.06,1.04-1.06.49,0,.87.35,1.07.61.06.07.25.14.36.01l1.46-1.69c.11-.12.1-.31-.02-.43l-.19-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M154.86,7.55c-1.14.02-1.95.74-2.38,1.72l-1.67-1.52s-.33-.26-.59.05l-1.58,1.6s-.25.21-.01.44c.24.23.91.72,1.09,1,0,0,.08.08.08.41v14.09c0,.1.11.15.19.09,0,0,1.21-.68,1.46-.86,1.26-.91,1.18-1.29,1.18-1.29v-3.39s0,0,0,0h0c5.46-1.28,5.55-6.94,5.55-6.94.17-3.73-1.61-5.41-3.32-5.38ZM152.62,18.09v-7.37c0-.81.26-.88.85-.88.18,0,1.7.13,1.7,3.07,0,3.78-1.84,4.93-2.56,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M145.17,7.69c-1.09,0-2.15.6-2.62,1.51-.45-.9-1.04-1.51-2.5-1.51-1.07,0-2.09.69-2.52,1.68l-1.67-1.52s-.33-.26-.59.05l-1.58,1.61s-.25.21-.01.44c.24.23.92.71,1.09.99,0,0,.08.08.08.41v8.22c0,.22.18.41.41.41h2.29c.08,0,.14-.06.14-.14v-8.65h0c0-.51.34-.95.82-1.06.7-.16,1.32.37,1.32,1.04v.18s0,8.22,0,8.22c0,.22.18.41.41.41h2.29c.08,0,.14-.06.14-.13v-8.32s0-.5,0-.5c.06-.56.55-1,1.14-.96.57.04.99.54.99,1.11v8.4c0,.22.18.41.41.41h2.28c.08,0,.14-.06.14-.14v-8.36s.02-1.07-.08-1.76c-.15-1.08-1.26-2.03-2.35-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M166.2,16.75c-.31.18-.87,1.03-2.5,1.03s-1.62-.98-1.63-1.19c0-.28.21-.42.27-.45,2.18-.82,3.22-1.98,3.72-2.98.56-1.14.41-2.08.41-2.08-.4-3.85-2.8-3.48-2.8-3.48-1.35,0-4.18,1.79-4.34,3.76v5.39c0,.24.03,1.02.09,1.17.26.64,1.15,2.23,3.75,2.16,3.38-.09,3.38-3.28,3.38-3.28-.16-.21-.35-.05-.35-.05ZM162.49,9.64c.4,0,1.6.09,1.59,2.46,0,0,0,2.52-1.92,2.71v-4.72s-.02-.45.33-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M194.4,18.56c-.2-.27-.69-1.09-.82-1.39,0,0-.04-.05-.04-.44V4.85h0v-2.5s-.02-.05-.05-.05c-.24.01-1.48.17-2.59,1.1-.07.06-.2.23-.19.6v1.12l-.03,12.56v.44c0,.12.05.24.14.34l1.08,1.5s.29.31.59.05l1.74-1.17s.26-.16.16-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M188.91,17.32s-.04-.05-.04-.44v-8.46c0-.23-.1-.39-.33-.43,0,0-1.63-.25-2.55-.25s-1.45.04-1.45.04c0,0-3.59.13-3.59,3.93v5.09c0,.14,0,3,2.84,3,0,0,0,0,0,0,.1,0,1.09.07,2.3-1.49.04-.05.12-.05.17,0l.98,1.73s.29.31.59.05l1.57-1.06s.27-.13.11-.42c-.19-.33-.46-.98-.59-1.28ZM186.1,17.46v.07s-1.17.02-1.38,0c-1.06-.11-1-.81-1-.98v-5.43c0-1.55,1.49-1.45,1.56-1.45.4,0,.82.03.82.03v7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M178.01,2.69s-.08-.03-.12,0l-1.41,1.35c-.22.22-.22.57,0,.79l1.19,1.16c.13.13.33.13.46,0l1.48-1.5s.03-.08,0-.12l-1.61-1.69Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "8.6 5.14 7.69 5.14 7.69 1.34 11.49 1.34 11.49 2.25 8.6 2.25 8.6 5.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "27.31 5.14 26.4 5.14 26.4 2.25 23.51 2.25 23.51 1.34 27.31 1.34 27.31 5.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "27.31 26.42 23.51 26.42 23.51 25.51 26.4 25.51 26.4 22.62 27.31 22.62 27.31 26.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "11.49 26.42 7.69 26.42 7.69 22.62 8.6 22.62 8.6 25.51 11.49 25.51 11.49 26.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "13.38 16.58 12.73 19.03 12.69 19.02 13.34 16.57 13.38 16.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "12.78 19.11 12.6 19.07 13.29 16.5 13.46 16.53 12.78 19.11"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.58 16.29 13.36 16.61 13.36 16.55 15.58 16.23 15.58 16.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "13.28 16.69 13.3 16.49 15.65 16.15 15.64 16.35 13.28 16.69"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "18.26 19.22 15.75 20.79 15.73 20.73 18.24 19.16 18.26 19.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.7 20.89 15.66 20.7 18.29 19.06 18.33 19.25 15.7 20.89"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "20.29 20.41 20.26 20.47 18.24 19.22 18.26 19.16 20.29 20.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "20.29 20.56 18.15 19.24 18.23 19.06 20.37 20.39 20.29 20.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "18.89 16.69 18.27 19.19 18.23 19.18 18.84 16.69 18.89 16.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "18.32 19.27 18.15 19.24 18.79 16.61 18.97 16.64 18.32 19.27"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M18.29,18.97c.09,0,.15.1.13.22s-.11.22-.2.22c-.09,0-.15-.1-.13-.22.02-.12.11-.22.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M18.22,19.47s0,0,0,0c-.05,0-.1-.03-.14-.07-.05-.06-.07-.14-.05-.23.03-.16.14-.27.27-.27h0c.05,0,.1.03.14.07.05.06.07.14.05.23-.03.15-.14.27-.26.27ZM18.28,19.03s-.12.07-.13.16c0,.05,0,.1.02.13.01.01.02.02.04.02,0,0,0,0,0,0,.05,0,.12-.07.13-.16,0-.05,0-.1-.02-.13-.01-.01-.02-.02-.04-.02,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17.62,14.61c.09,0,.15.1.13.22s-.11.22-.2.22-.15-.1-.13-.22c.02-.12.11-.22.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17.55,15.12s0,0,0,0c-.05,0-.1-.03-.14-.07-.05-.06-.07-.14-.05-.23.03-.15.14-.27.26-.27,0,0,0,0,0,0,.05,0,.1.03.14.07.05.06.07.14.05.23-.03.15-.14.27-.26.27ZM17.61,14.68s-.12.07-.13.16c0,.05,0,.1.02.13.01.01.02.02.04.02,0,0,0,0,0,0,.05,0,.12-.07.13-.16,0-.05,0-.1-.02-.13-.01-.01-.02-.02-.04-.02h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M13.4,16.36c.09,0,.15.1.13.22-.02.12-.11.22-.2.22-.09,0-.15-.1-.13-.22.02-.12.11-.22.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M13.32,16.86s0,0,0,0c-.05,0-.1-.03-.14-.07-.05-.06-.07-.14-.05-.23.03-.15.14-.27.27-.27h0c.05,0,.1.03.14.07.05.06.07.14.05.23-.03.15-.14.27-.26.27ZM13.39,16.42s-.12.07-.13.16c0,.05,0,.1.02.13.01.01.02.02.04.02,0,0,0,0,0,0,.05,0,.12-.07.13-.16,0-.05,0-.1-.02-.13-.01-.01-.02-.02-.04-.02,0,0,0,0,0,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.77 20.76 15.74 20.83 12.69 19.03 12.72 18.96 15.77 20.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.77 20.92 12.6 19.06 12.69 18.86 15.86 20.73 15.77 20.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.61 16.31 12.72 19.02 12.69 18.96 15.59 16.25 15.61 16.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "12.69 19.13 12.61 18.95 15.61 16.13 15.69 16.32 12.69 19.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.79 20.78 15.73 20.8 15.57 16.29 15.63 16.27 15.79 20.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.66 20.89 15.5 16.24 15.69 16.18 15.85 20.83 15.66 20.89"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "18.9 16.76 15.77 20.82 15.74 20.77 18.87 16.71 18.9 16.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.77 20.93 15.66 20.77 18.87 16.6 18.98 16.76 15.77 20.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "18.89 16.69 18.88 16.77 15.59 16.31 15.61 16.24 18.89 16.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "18.93 16.85 15.51 16.37 15.56 16.16 18.97 16.64 18.93 16.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "17.64 24.18 17.59 24.23 15.73 20.82 15.78 20.77 17.64 24.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "17.57 24.35 15.65 20.81 15.8 20.66 17.72 24.19 17.57 24.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "20.24 20.5 15.75 20.83 15.76 20.76 20.25 20.42 20.24 20.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "15.68 20.9 15.7 20.69 20.32 20.35 20.3 20.56 15.68 20.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "20.27 20.44 20.22 20.48 18.86 16.76 18.91 16.71 20.27 20.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "20.19 20.59 18.78 16.73 18.94 16.6 20.35 20.46 20.19 20.59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "20.27 20.49 17.63 24.23 17.59 24.19 20.23 20.44 20.27 20.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "17.64 24.34 17.51 24.19 20.22 20.33 20.35 20.48 17.64 24.34"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "22.22 16.23 18.88 16.77 18.88 16.7 22.22 16.16 22.22 16.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "18.82 16.85 18.82 16.64 22.29 16.08 22.29 16.29 18.82 16.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "22.25 16.21 20.27 20.48 20.22 20.45 22.2 16.18 22.25 16.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "20.3 20.57 20.14 20.47 22.17 16.09 22.33 16.18 22.31 16.24 20.3 20.57"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M12.76,18.72c.11,0,.18.13.15.28-.03.15-.14.27-.25.27-.11,0-.18-.13-.15-.28.03-.15.14-.27.25-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M12.67,19.33s0,0,0,0c-.06,0-.12-.03-.16-.08-.06-.07-.08-.17-.06-.27.03-.18.17-.32.31-.32.06,0,.12.03.16.08.06.07.08.17.06.27-.03.18-.17.32-.31.32ZM12.75,18.79c-.07,0-.16.09-.18.21-.01.07,0,.13.03.17.02.02.04.03.06.03,0,0,0,0,0,0,.07,0,.16-.09.18-.21.01-.07,0-.13-.03-.17-.02-.02-.04-.03-.06-.03h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M15.79,20.49c.11,0,.18.13.15.28-.03.15-.14.27-.25.26-.11,0-.18-.13-.15-.28.03-.15.14-.27.25-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M15.7,21.09s0,0,0,0c-.06,0-.12-.03-.16-.08-.06-.07-.08-.17-.06-.27.03-.18.17-.32.31-.32h0c.06,0,.12.03.16.08.06.07.08.17.06.27-.03.18-.16.32-.31.32ZM15.78,20.55c-.07,0-.16.09-.18.21-.01.07,0,.13.03.17.02.02.04.03.06.03.07,0,.16-.08.18-.21.01-.07,0-.13-.03-.17-.02-.02-.04-.03-.06-.03h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M15.63,15.98c.11,0,.18.13.15.28-.03.15-.14.27-.25.26-.11,0-.18-.13-.15-.28.03-.15.14-.27.25-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M15.55,16.58s0,0,0,0c-.06,0-.12-.03-.16-.08-.06-.07-.08-.17-.06-.27.03-.18.16-.32.31-.32,0,0,0,0,0,0h0c.06,0,.12.03.16.08.06.07.08.17.06.27-.03.18-.16.32-.31.32ZM15.63,16.04c-.07,0-.16.09-.18.21-.01.07,0,.13.03.17.02.02.04.03.06.03.06,0,.16-.08.18-.21.01-.07,0-.13-.03-.17-.02-.02-.04-.03-.06-.03h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M18.91,16.42c.11,0,.18.13.15.28-.03.15-.14.27-.25.27s-.18-.13-.15-.28c.03-.15.14-.27.25-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M18.82,17.03s0,0,0,0c-.06,0-.12-.03-.16-.08-.06-.07-.08-.17-.06-.27.03-.18.16-.32.31-.32,0,0,0,0,0,0h0c.06,0,.12.03.16.08.06.07.08.17.06.27-.03.18-.16.32-.31.32ZM18.91,16.49c-.07,0-.16.09-.18.21-.01.07,0,.13.03.17.02.02.04.03.06.03,0,0,0,0,0,0,.07,0,.16-.09.18-.21.01-.07,0-.13-.03-.17-.02-.02-.04-.03-.06-.03h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17.65,23.83c.11,0,.18.13.15.28-.03.15-.14.27-.25.26s-.18-.13-.15-.28c.03-.15.14-.27.25-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17.56,24.44s0,0,0,0c-.06,0-.12-.03-.16-.08-.06-.07-.08-.17-.06-.27.03-.18.17-.32.31-.32.06,0,.12.03.16.08.06.07.08.17.06.27-.03.18-.17.32-.31.32ZM17.65,23.9c-.07,0-.16.09-.18.21-.01.07,0,.13.03.17.02.02.04.03.06.03,0,0,0,0,0,0,.07,0,.16-.09.18-.21.01-.07,0-.13-.03-.17-.02-.02-.04-.03-.06-.03,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M20.3,20.15c.11,0,.18.13.15.28s-.14.27-.25.26-.18-.13-.15-.28c.03-.15.14-.27.25-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M20.21,20.76s0,0,0,0c-.06,0-.12-.03-.16-.08-.06-.07-.08-.17-.06-.27.03-.18.16-.32.31-.32,0,0,0,0,0,0h0c.06,0,.12.03.16.08.06.07.08.17.06.27-.03.18-.16.32-.31.32ZM20.29,20.22c-.07,0-.16.09-.18.21-.01.07,0,.13.03.17.02.02.04.03.06.03,0,0,0,0,0,0,.07,0,.16-.09.18-.21.01-.07,0-.13-.03-.17-.02-.02-.04-.03-.06-.03h0s0,0,0,0Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M18.14,17.97c.14.17.11.42-.05.55s-.42.11-.55-.05-.11-.42.05-.55.42-.11.55.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17.84,18.68s-.03,0-.05,0c-.12-.01-.23-.07-.31-.17-.08-.09-.11-.21-.1-.34s.07-.23.17-.31c.2-.16.48-.13.65.06h0c.16.2.13.49-.06.65-.08.07-.18.1-.29.1ZM17.84,17.89c-.07,0-.15.02-.21.07-.07.06-.11.13-.12.22,0,.09.02.17.07.24.06.07.13.11.22.12.09,0,.17-.02.24-.07.14-.11.16-.32.04-.46-.06-.08-.16-.12-.25-.12Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M15.89,16.43s0-.03-.01-.05c-.07-.32-.44-1.61.32-3.89.14-.42-.14-.27-.34.06-.13.22-.86,1.76-.64,3.91.02,0,.05,0,.07,0,.2-.02.4-.03.6-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M14.6,16.47c.1,0,.2,0,.31,0-.14-.64-.27-1.63-.02-2.73.09-.39-.13-.29-.34.23-.13.32-.38,1.24-.24,2.5,0,0,0,0,.01,0,.09,0,.19,0,.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M21.51,16.37c.12,0,.23.01.35.03-.06-.44-.18-.92-.39-1.43-.18-.45-.43-.38-.26,0,.06.14.27.67.31,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M21.1,16.36c-.02-.32-.08-.64-.18-.93-.11-.34-.27-.21-.22.14.03.23.05.5.05.8.12,0,.23-.01.35-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M13.57,16.37c-.19-1.13.08-2.18.66-3.05.37-.56.62-1.07.65-1.66.06-1.09.16-1.87.85-2.86s.18-1.43.61-2.49c.43-1.06,1.05-1.24,1.17-1.41.17-.25.28-.96.29-1.14,0-.14.1-.09.13,0,.04.14.08.54-.09,1.06-.06.18-.04.35.17.01.23-.37.25-.96.01-1.4-.19-.35-.31-.28-.48-.05-.1.14-.45.76-.57,1.35-.04.19-.95.64-1.11,2.45-.12,1.41-.72,1.35-1.16,2.89-.43,1.47.02,1.76-.94,3.19-.62.92-.81,1.97-.7,3.03.17.02.35.04.52.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M19.63,10.76c-.1.16-.89,1.23-1.37,4.13-.06.35-.21.38-.22.03,0-.49,0-1.82.65-3.62.18-.5-.08-.4-.33.01-.27.43-1.03,1.75-1.24,4.19-.03.29-.18.41-.24.07-.03-.17-.17-1.64.46-3.67.15-.47-.2-.18-.33.08-.12.24-1.02,1.92-.91,4.28,0,.07,0,.12-.01.17.29,0,.58.02.86.03.12,0,.24,0,.35,0,.6-.33,1.23-.54,1.76-.92,1.06-.77,1.56-2.66,1.07-3.95-.06-.16.01-.22.14-.04.1.15.88,1.17.14,3.09-.14.36.08.25.2.01.14-.26,1.25-2.24-.63-4-.17-.16-.27-.04-.37.11ZM19.06,15.06c-.08,0,.14-.67.31-.63.25.07-.2.64-.31.63ZM19.87,12.19c.07.44,0,1.22-.17,1.58-.17.36-.33.34-.23-.06.14-.53.25-1.07.2-1.55-.04-.36.13-.41.2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17.29,7.12c.09-.36.47-1.93.13-1.37-.46.77-.64,2.03-.67,1.39-.02-.37.11-.83.08-.89-.1-.21-.64.91-.32,1.88.04.11.63,0,1.14-.62.65-.78.71-1.63.79-1.85.06-.17.22.55-.09,1.4-.11.3-.15.62.15.15.21-.33.63-1.16.08-1.99-.12-.18-.33-.35-.43.08-.27,1.12-1.04,2.58-.85,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17.55,10.28c-.18-1.37.57-2.52.41-2.39-.97.83-1.31,3-1.34,2.78-.14-1.1.5-2.32.25-2.09-.71.65-1.02,2.81-1.09,2.39-.08-.57.4-1.96.2-1.74-1.06,1.14-.54,2.65-.39,2.5.45-.44,1.93-.6,2.77-1.5.91-.98.62-2.51.73-2.36.7,1.01-.19,2.46-.19,2.46,1.82-1.48.19-3.16.05-3.03-1.06,1.05-1.39,3.14-1.41,2.97ZM18.36,9.4c.17-.33.25-.56.32-.97.05-.28.2-.35.18.07-.02.32-.18.77-.36,1.07-.19.31-.37.29-.13-.17ZM17.96,10.18c.02-.08.19-.37.26-.23.08.17-.3.39-.26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M19.97,16.07c0,.08,0,.21,0,.39.11-.01.21-.03.32-.04-.01-.16-.03-.32-.06-.47-.06-.31-.24-.27-.25.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 5.57,
    y: 16.03,
    width: 24.28,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M50.34,4.85v1.48c0,.42.07.85.23,1.29l1.05,3.21,1.06-3.21c.16-.48.23-.92.23-1.29v-1.48h1.15v1.38c0,.59-.09,1.14-.27,1.67l-1.44,4.23h-1.49l-1.43-4.23c-.18-.53-.27-1.09-.27-1.67v-1.38h1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M60.04,4.85v5.37c0,.48.38.86.86.86h.51c.48,0,.86-.38.86-.86v-5.37h1.15v5.37c0,.55-.2,1.03-.6,1.43-.39.39-.86.59-1.42.59h-.51c-.56,0-1.03-.19-1.43-.59s-.59-.87-.59-1.43v-5.37h1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M68.63,4.85h4.41v1.15h-3.26v1.92h2.94v1.15h-2.94v1.92h3.26v1.15h-4.41v-7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M79.39,4.85v6.13h3.16v1.15h-4.31v-7.28h1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M92.05,4.85v1.15h-1.76v6.13h-1.15v-6.13h-1.76v-1.15h4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M101.48,9.2c.05.27.2.91.2,1.57v1.37h-1.15v-1.58h-2.59v1.58h-1.15v-1.37c0-.67.14-1.3.19-1.57l.02-.1.95-3.39c.16-.55.68-.96,1.28-.96s1.12.39,1.29.96l.94,3.39.02.1ZM100.34,9.41s-.01-.04-.01-.05l-.91-3.31c-.03-.1-.1-.14-.19-.14-.11,0-.17.04-.19.14l-.91,3.31s-.01.04-.01.05h2.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M37.91,6.76h1.34c.3,0,.56.11.77.32.22.21.32.47.32.78v2.13c0,.31-.11.57-.32.79s-.47.32-.77.32h-1.34v-4.34ZM39.25,10.79c.22,0,.41-.08.56-.23.16-.16.23-.35.23-.57v-2.13c0-.22-.08-.41-.23-.56-.15-.16-.34-.23-.56-.23h-1.03v3.73h1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M43,6.76h2.43v.3h-2.13v1.71h1.93v.3h-1.93v1.71h2.13v.3h-2.43v-4.34Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M52.48,20.87v.83h-.3v-.83s0-.13-.01-.29h-1.97c-.01.12-.02.22-.02.29v.83h-.3v-.83c0-.28.04-.58.11-.91l.6-2.2c.07-.26.31-.45.59-.45s.52.19.59.45l.6,2.2c.08.29.11.59.11.91ZM52.12,20.28c0-.07-.03-.15-.05-.24l-.6-2.19c-.05-.3-.55-.3-.6,0l-.6,2.19c-.03.1-.04.17-.05.24h1.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M59.75,17.37c-.07-.39-.43-.69-.84-.69h-.51c-.48,0-.86.39-.86.86v3.45c0,.48.38.86.86.86h.51c.42,0,.77-.31.84-.69l1.11.32c-.12.44-.35.81-.71,1.1-.36.29-.78.43-1.24.43h-.51c-.56,0-1.03-.19-1.43-.59s-.59-.87-.59-1.43v-3.45c0-.55.19-1.02.59-1.42.39-.39.86-.6,1.43-.6h.51c.46,0,.87.15,1.24.44.36.29.6.65.71,1.09l-1.11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M70.35,19.97c.05.27.2.91.2,1.57v1.37h-1.15v-1.58h-2.59v1.58h-1.15v-1.37c0-.67.14-1.3.19-1.57l.02-.1.95-3.39c.16-.55.68-.96,1.28-.96s1.12.39,1.29.96l.94,3.39.02.1ZM69.21,20.18s-.01-.04-.01-.05l-.91-3.31c-.03-.1-.1-.14-.19-.14-.11,0-.17.04-.19.14l-.91,3.31s-.01.04-.01.05h2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M76.29,21.16c.07.39.44.69.85.69h.72c.47,0,.86-.38.86-.86s-.29-.85-.86-1.08l-.91-.34c-1.08-.43-1.62-1.11-1.62-2.03,0-.56.19-1.03.59-1.43s.87-.59,1.43-.59h.5c.47,0,.88.14,1.25.43.36.29.6.65.7,1.09l-1.11.32c-.07-.38-.43-.68-.84-.68h-.5c-.48,0-.86.38-.86.86,0,.42.18.68.91.97l.92.35c.98.39,1.57,1.15,1.57,2.13,0,.56-.2,1.03-.6,1.43s-.86.59-1.42.59h-.72c-.47,0-.88-.14-1.25-.43-.36-.29-.6-.66-.7-1.1l1.1-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M89.39,19.97c.05.27.2.91.2,1.57v1.37h-1.15v-1.58h-2.59v1.58h-1.15v-1.37c0-.67.14-1.3.19-1.57l.02-.1.95-3.39c.16-.55.68-.96,1.28-.96s1.12.39,1.29.96l.94,3.39.02.1ZM88.25,20.18s-.01-.04-.01-.05l-.91-3.31c-.03-.1-.1-.14-.19-.14-.11,0-.17.04-.19.14l-.91,3.31s-.01.04-.01.05h2.22Z"
  })))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.84,
    y1: 0.77,
    x2: 116.84,
    y2: 26.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAssets08);
export default __webpack_public_path__ + "static/media/SVG_assets-08.fa4a137411f79bd8f6d10d57614a1009.svg";
export { ForwardRef as ReactComponent };